import { Flex, IconButton, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { EmptyState, Icon } from "@pufflig/prompt-studio-ui";
import { DataTypeInfo } from "../DataTypeInfo/DataTypeInfo";

interface SchemaPreviewProps {
  readOnly?: boolean;
  headers: string[];
  fields: Array<{ fieldName: string; variableName: string; type: string; description?: string }>;
  onRemoveField?: (id: string) => void;
}

interface FieldProps {
  fieldName: string;
  variableName: string;
  description?: string;
  readOnly?: boolean;
  type: string;
  onRemove: () => void;
}

const Field = (props: FieldProps) => {
  return (
    <Tr>
      <Td padding="1">{props.fieldName}</Td>
      <Td padding="1">{props.variableName}</Td>
      <Td padding="1" maxWidth="180px">
        <Text noOfLines={1}>{props.description}</Text>
      </Td>
      <Td padding="1">
        <DataTypeInfo type={props.type} />
      </Td>
      <Td padding="1">
        {!props.readOnly && (
          <IconButton
            onClick={props.onRemove}
            color="foreground.secondary"
            aria-label="Copy"
            icon={<Icon name="minus-cirlce" />}
            size="sm"
            variant="ghost"
            _hover={{ bg: "background.tertiary" }}
          />
        )}
      </Td>
    </Tr>
  );
};

export const SchemaPreview = (props: SchemaPreviewProps) => {
  const { fields = [], readOnly, onRemoveField, headers = [] } = props;
  if (!fields.length)
    return (
      <EmptyState
        showBackground
        title="No fields"
        description="Add placeholders to pass external values to your Promptbook."
      />
    );
  return (
    <TableContainer>
      <Table variant="simple">
        <Thead>
          <Tr>
            {headers.map((header, index) => {
              return (
                <Th padding="1" key={index}>
                  <Flex alignItems="center" gap="0.5">
                    <Text color="secondary" textStyle="label/S/regular" textTransform="none">
                      {header}
                    </Text>
                  </Flex>
                </Th>
              );
            })}
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {fields.map((f, index) => (
            <Field
              readOnly={readOnly || !onRemoveField}
              key={index}
              fieldName={f.fieldName}
              variableName={f.variableName}
              description={f.description}
              type={f.type}
              onRemove={() => {
                onRemoveField?.(f.fieldName);
              }}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
